import '../styles/loading-state.css';

const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const sizes = new Set(['text', 'short', 'title', 'value', 'badge', 'avatar', 'button']);
export const skeleton = (size = 'text') => `<span class="app-skeleton app-skeleton--${sizes.has(size) ? size : 'text'}" aria-hidden="true"></span>`;
export const loadingStatus = (label = 'Loading') => `<div class="app-loading-status" role="status"><span class="app-loading-dot" aria-hidden="true"></span>${esc(label)}</div>`;
const row = () => `<div class="app-loading-row">${skeleton('avatar')}<div class="app-loading-copy">${skeleton('title')}${skeleton('text')}</div>${skeleton('badge')}${skeleton('short')}</div>`;
const card = () => `<div class="app-loading-card">${skeleton('avatar')}${skeleton('title')}${skeleton('text')}${skeleton('short')}</div>`;

/** Decorative placeholders never stand in for actual counts, chart data or controls. */
export function loadingState(kind = 'list', label = 'Loading') {
  const shapes = {
    list: `<div class="app-loading-rows">${row().repeat(3)}</div>`,
    cards: `<div class="app-loading-cards">${card().repeat(3)}</div>`,
    chart: '<div class="app-loading-chart"><span></span><span></span><span></span></div>',
    detail: `<div class="app-loading-heading">${skeleton('title')}${skeleton('text')}</div><div class="app-loading-cards">${card().repeat(2)}</div>`,
    editor: `<div class="app-loading-heading">${skeleton('title')}${skeleton('text')}</div><div class="app-loading-editor"><div class="app-loading-card">${skeleton('text').repeat(4)}</div><div class="app-loading-card">${skeleton('title')}${skeleton('text').repeat(3)}${skeleton('button')}</div></div>`,
    metrics: `<div class="app-loading-metrics">${skeleton('value')}${skeleton('value')}</div>`,
  };
  return `<div class="app-loading" data-loading-state>${loadingStatus(label)}<div aria-hidden="true">${shapes[kind] || shapes.list}</div></div>`;
}

const refreshes = new WeakMap();
/** Keep existing data in place, and let only the latest request clear its indicator. */
export function beginRefresh(target, label = 'Updating') {
  if (!target) return () => {};
  refreshes.get(target)?.();
  if (target.querySelector('[data-loading-state]')) return () => {};
  const indicator = document.createElement('div');
  indicator.className = 'app-refresh-status';
  indicator.innerHTML = loadingStatus(label);
  target.before(indicator);
  target.setAttribute('aria-busy', 'true');
  const done = () => {
    indicator.remove();
    if (refreshes.get(target) === done) {
      target.removeAttribute('aria-busy');
      refreshes.delete(target);
    }
  };
  refreshes.set(target, done);
  return done;
}

export function settleLoadingValues(root) {
  root?.querySelectorAll('.app-loading-value').forEach(value => value.replaceWith('—'));
}

/** Stop other first-load placeholders when a shared report request fails. */
export function failLoadingStates(root) {
  settleLoadingValues(root);
  root?.querySelectorAll('.app-loading').forEach(state => {
    const message = document.createElement('p');
    message.className = 'app-loading-unavailable';
    message.textContent = 'Data unavailable';
    state.replaceWith(message);
  });
}
